import { render, staticRenderFns } from "./ds-editor.vue?vue&type=template&id=75e82ead&scoped=true"
import script from "./ds-editor.vue?vue&type=script&lang=ts"
export * from "./ds-editor.vue?vue&type=script&lang=ts"
import style0 from "./ds-editor.vue?vue&type=style&index=0&id=75e82ead&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e82ead",
  null
  
)

export default component.exports